'use strict';

const { h } = require('phy');

const OfferAdvertImage = require('../../shared/views/adverts/mpu-advert-image');
const OfferRedemptionText = require('../../shared/views/offer/offer-redemption-text');
const OfferExclusive = require('../../shared/views/offer/offer-exclusive');
const { getButtonUrl } = require('../../support/slug-helper');

function CouponAdvert({ routes, coupon, lazy = true }) {
  if (!coupon) return null;

  const {
    merchantSlug,
    destination,
    isExclusive,
    merchantName,
    id,
    offerTitle,
    offerCallout,
    media,
    offerType,
    advertName,
  } = coupon;

  const buttonUrl = getButtonUrl({
    routes,
    merchantSlug,
    destination,
  });

  const ExclusiveElement =
    isExclusive && OfferExclusive({ className: 'coupon-advert-exclusive' });

  const targetTags = merchantSlug
    ? {}
    : {
        target: '_blank',
        rel: 'noopener',
      };

  return h(
    'a.coupon-advert',
    {
      href: buttonUrl,
      ...targetTags,
      'data-bhc': `CarouselItem:${id}`,
    },
    [
      h('.coupon-advert-logo', { title: offerTitle }, [
        OfferAdvertImage({
          className: 'coupon-advert-image',
          alt: `${merchantName} - ${offerCallout}`,
          data: media,
          size: ['w_280'],
          lazy,
        }),
      ]),
      h('.coupon-advert-content', [
        ExclusiveElement,
        h('p.coupon-advert-title', offerTitle || advertName),
        OfferRedemptionText({
          className: 'coupon-advert-type',
          type: offerType,
        }),
      ]),
    ]
  );
}

module.exports = CouponAdvert;
